import { Observable, filter } from 'rxjs';

function isTruthy<T>(value: T): value is NonNullable<T> {
    return !!value;
}

export function filterTruthy<T>(source$: Observable<T>): Observable<NonNullable<T>> {
    return source$.pipe(filter(isTruthy));
}
